import styled from "@emotion/styled"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import { Container, Typography } from "@mui/material"

export const Section = styled(SectionWrapper)`
  padding-top: ${({ theme }) => theme.typography.pxToRem(144)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }
`

export const Wrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(52)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(64)};
  letter-spacing: -0.52px;
  max-width: 732px;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(20)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(36)};
    line-height: ${({ theme }) => theme.typography.pxToRem(48)};
    font-weight: 500;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(26)};
  opacity: 0.9;
  max-width: 370px;
  text-align: center;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(48)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(17)};
    line-height: ${({ theme }) => theme.typography.pxToRem(24)};
    font-weight: 400;
    opacity: 0.8;
  }
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  ${({ theme }) => theme.breakpoints.down("md")} {
    flex-direction: column;
  }
`
